export default __webpack_public_path__ + "static/media/maria.507b0eda.png";